import { render, staticRenderFns } from "./AddressCategoryList.vue?vue&type=template&id=41ac3b48&"
import script from "./AddressCategoryList.vue?vue&type=script&lang=js&"
export * from "./AddressCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports